/* eslint-disable max-len */

export default {
  lang: 'Spanish',
  homeScreen: {
    title: '',
    stayConnected: '¡Sigue conectado!',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
  },
  loginScreen: {
    title: 'Programa de capacitación de asesores profesionales de turismo y ventas',
    welcome: {
      headerTop: 'Te damos la bienvenida a',
      headerBottom: 'NSAA',
    },
    sellingPoints: {
      0: 'Aprende, promociona y vende en el camino',
      1: 'Capacitación multimedia en todos los dispositivos',
      2: 'Certificado de finalización',
      3: 'Presentaciones de ventas preparadas con anticipación',
      4: 'Material promocional de gran impacto',
      5: 'Consejos de los expertos y promociones',
      6: 'Directorio de productos en tiempo real',
      7: 'Novedades y actualizaciones periódicas',
    },
    emailPrompt: 'Ingresa tu dirección de correo electrónico y tu contraseña para confirmar que eres un asesor profesional de turismo.',
    tAndC: {
      agree: 'Al continuar, aceptas nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      agency: 'Agencia',
      salutation: 'Saludo *',
      email: 'Correo electrónico *',
      password: 'Contraseña *',
      passwordConfirm: 'Confirma tu contraseña *',
      firstName: 'Nombre *',
      lastName: 'Apellido *',
      city: 'Ciudad *',
      agencyName: 'Nombre de la agencia *',
      stateProvince: 'Estado/provincia *',
      required: 'Requerido',
      invalidEmail: 'Dirección de correo electrónico no válida',
      opt: '¡Mantente en contacto! ¡Sí, me gustaría optar por recibir comunicaciones de NSAA que me mantengan informado sobre noticias, eventos, incentivos, de FAM y más!',
      complete: 'Paso 2: Complete su perfil',
      tell: 'Cuéntanos sobre ti',
      title: 'Título comercial *',
      host: 'Nombre de la agencia anfitriona',
      country: 'País/Región',
      select: 'Seleccione una opción a continuación',
      header2: '¿Qué segmento(s) vende principalmente?',
      step2: 'Describe tu negocio',
      leisure: 'Ocio',
      corporate: 'Corporativo',
      group: 'Grupo',
      what: '¿Qué tipo de viaje venden?',
      what1: '¿Qué tipo de viaje venden?',
      what2: '¿Cuál es el segundo tipo de viaje que vendes?',
      what3: '¿Cuál es el tercer tipo de viaje que vendes?',
      affiliate: '¿Cuál es su afiliación principal?',
      forgot: 'Proporcione la dirección de correo electrónico que utilizó cuando se registró en su cuenta de NSAA. Le enviaremos un correo electrónico que le permitirá restablecer su contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy un asesor',
      title: 'Agradecemos tu interés en NSAA',
      messageWeb: 'El contenido de este sitio es exclusivo para asesores profesionales de turismo. Para obtener más información sobre NSAA County, visita:',
      messageMobile: 'Algunos contenidos en esta aplicación son exclusivos para asesores profesionales de turismo, pero puedes echar un vistazo a lo que ofrece esta aplicación haciendo clic en "Continuar".',
      continue: 'Continuar',
      visitWebsite: 'Visita el sitio web',
    },
    newUser: 'Nuevo usuario',
    register: 'Regístrate',
    registered: 'Este correo electrónico ya se encuentra registrado',
    forgot: 'Olvidé mi contraseña',
     header: 'Tómese un momento para completar toda la información a continuación, ya que esto es lo que llenará su perfil e información de contacto.',
     step1: 'Paso 1: Complete su dirección de correo electrónico y elija una contraseña.',
  },
  welcomeScreen: {
    title: 'Te damos la bienvenida a NSAA',
    helloUser: 'Hola, {{name}}',
    hello: 'Hola:',
    fromAgency: 'de {{agency}}',
    notUser: '¿No eres {{name}}?',
    introOnline: '¡Capacítate de manera inmediata en línea o precarga el contenido para que esté siempre disponible y puedas usarlo sin conexión!',
    introOffline: 'Ya tienes la última versión precargada. ¡Comienza la capacitación o la venta en cualquier momento y lugar!',
    startTraining: 'Comienza el aprendizaje',
    continueTraining: 'Continúa con el aprendizaje',
    graduated: '¡Felicitaciones!',
    downloader: {
      preload: 'Precargar',
      stop: 'Detener',
      init: 'Iniciando...',
      lastUpdate: 'Última actualización:',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number} % completo',
    unlock: 'Desbloquea este capítulo completando el capítulo de capacitación {number}.',
    unlockSubtitle: 'Desbloquea más capítulos completando los capítulos de capacitación.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificar',
    courseComplete: 'Continuar',
    endReached: 'Has llegado al final',
    retainEnd: 'Utiliza la barra superior para navegar por este capítulo, o haz clic en el botón "Atrás" para regresar a la descripción general.',
    watchListenRead: 'Mira, escucha y lee más',
    trouble: 'Parece que tienes problemas, vuelve a leer el contenido de la (las) página(s) anterior(es) e inténtalo nuevamente.',
    confirm: 'Confirma tu respuesta',
    choose: 'Elige una respuesta',
    skip: 'Regresar >',
    viewAllTitle: 'Consejo de capacitación',
    viewAll: 'Para pasar a la página siguiente, haz clic en los íconos para ver el contenido adicional. Te hemos proporcionado vídeos, mapas y otra información útil para mejorar tu capacitación y asegurarte de que alcances el status PRO.',
    fillBlanks: 'Completa el (los) espacio(s) en blanco:',
    next: 'Siguiente pregunta',
    retry: 'Vuelve a intentarlo',
    fastTrackText: {
      success: '¡Felicitaciones, has aprobado el curso Fast Track y has desbloqueado el resto de la capacitación!',
      failed: 'Desafortunadamente no has aprobado el curso Fast Track. ¡Pero puedes retomar tu capacitación para obtener el diploma!',
    },
    fastTrack: '¡Conviértete en una Swiss Travel Superstar!',
    fastTrackExplanation: '¡Solo tienes que completar el cuestionario en las siguientes páginas para tener la oportunidad de ganar un FAM a Suiza!<br><br><span style="font-weight: bold">Encontrarás todas las respuestas a las preguntas de la siguiente manera:</span><br><br>1. El contenido que has aprendido en los módulos Rail Europe y Suiza<br><br>2. Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">¡Asegúrate de revisar estos recursos detalladamente antes de realizar el cuestionario! Solo las personas que hayan obtenido el mayor puntaje tendrán la oportunidad de ser invitadas al FAM.</span>',
    fastTrackButton: 'Haz clic aquí para responder el cuestionario Swiss Superstar',
    grading: 'Tu puntaje final es: {grade} %',
  },
  nav: {
    home: 'Inicio',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Retener',
    directory: 'Directorio',
    showRoom: 'Exhibiciones',
    showcases: 'Exhibiciones',
    offers: 'Ofertas',
    promote: 'Promocionar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Premios',
    media: 'Medios de comunicación',
    favorites: 'Favoritos',
    contact: 'Información de contacto',
    reportCard: 'Ver diploma',
    accountSettings: 'Ajustes de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Retener',
    subapps: 'Módulos de los asociados de NSAA County',
    maintrainings: 'La fundación',
    subtrainings: 'La experiencia',
  },
  pageDescriptions: {
    train: 'Aprende, participa y conviértete en un experto',
    showroom: '',
    retain: '¡Felicitaciones, has completado la capacitación! Acabas de desbloquear tu recurso de apoyo para retener tus conocimientos de experto y facilitar tus esfuerzos de ventas. Utiliza esta sección para responder de forma experta a preguntas sobre los productos o incluso realizar una presentación de ventas improvisada, en cualquier momento y lugar, y desde cualquier dispositivo.',
    promote: 'Comparte estos elementos para despertar el interés e iniciar una conversación con (posibles) clientes.',
    sell: 'Responde las preguntas y cierra la venta como un experto con recursos consolidados y apoyo comercial específico.',
    favorites: 'Revisa personalmente el contenido de tu preferencia',
    search: 'Revisa todo el contenido',
    subapps: '',
    maintrainings: 'Comienza por lo básico sobre NSAA County y los lugares donde se pueden alojar tus clientes.',
    subtrainings: 'Completa estos módulos sobre todas las increíbles cosas que los clientes pueden hacer y ver en NSAA County, y recibe tu certificado como experto oficial en NSAA County.',
  },
  general: {
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'No se encontró la imagen',
    noResultsFor: 'No se encontraron resultados para: {{query}}',
    noFavorites: 'Todavía no tienes ningún favorito.',
    noMessages: '¡Aún no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: 'Error 404: ¡no se encontró la página!',
    oops: 'Oh oh...',
    overview: 'Regresar a la descripción general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo completo!',
    chapterComplete: '¡Capítulo completado!',
    message: '{count} mensaje',
    messagePlural: '{count} mensajes',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Colección',
    layout: 'Diseño',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Colección',
  },
  questions: {
    dials: 'Gira los diales para que coincidan con la respuesta',
    fitb: 'Completa el (los) espacio(s) en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Elige la (las) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el control deslizante',
    map: 'Toca la ubicación correcta en el mapa para responder la pregunta',
    dropdown: 'Elige...',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Darse de baja',
    settings: 'Ajustes de privacidad',
    message: '¡No nos has comentado nada acerca de tus preferencias sobre la privacidad de datos! Está bien; sin embargo, nos gustaría ofrecerte la mejor experiencia de uso del recurso de ventas.',
    disabled: 'Parece que has deshabilitado el uso de las cookies.',
    use: '{{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Aprende cómo habilitar tus cookies {{here}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Visitante',
  },
  demo: {
    message: 'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    copyURL: 'Copiar el enlace',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visita tu tienda de aplicaciones y busca {appName}, o haz clic en uno de los siguientes botones',
    benefits: {
      1: 'Aprende, promociona y vende en el camino',
      2: 'Capacitación multimedia en todos los dispositivos',
      3: 'Certificado de finalización',
      4: 'Presentaciones de ventas preparadas con anticipación',
      5: 'Material promocional de gran impacto',
      6: 'Directorio de productos en tiempo real',
      7: 'Novedades y actualizaciones periódicas',
      header: 'Esto te proporcionará:',
    },
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Cantidad de Resultados:',
    filter: 'Filtrar',
    filters: 'Filtros:',
    resetFilters: 'Restablecer Filtros',
    showResults: 'Mostrar Resultados',
    noResults: 'No se han encontrado resultados. Intente con una búsqueda diferente.',
    resetMap: 'Restablecer mapa para comenzar >',
    viewNow: 'Ver Ahora >',
  },
  directory: {
    artsentertainment: 'Arte y Entretenimiento',
    conventionservices: 'Servicios de convenciones',
    divingsnorkeling: 'Buceo y Snorkeling',
    film: 'Película',
    hotels: 'Hoteles',
    lgbtgymsandspas: 'LGBT+: Gimnasios y Spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Dónde Alojarse',
    multiculturaldining: 'Multicultural: Comida',
    multiculturalnightlife: 'Multicultural: La vida nocturna',
    nightlife: 'Vida Nocturna',
    petfriendly: 'Mascota amigable',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Balnearios',
    sports: 'Deportes',
    transportation: 'Transporte',
    venues: 'Lugares',
    waterways: 'Vías Navegables',
    waystoplay: 'Formas de jugar',
    weddinglocations: 'Lugares de bodas',
    weddingvendors: 'Vendedores de bodas',
  },
  custom: {
    splitUsers: 'Soy un...',
    brandAmbassador: 'Embajador de la marca',
    travelPro: 'Asesor profesional de turismo',
  },
};
